import { useRef, useEffect } from 'react'
import { zoomInitialState, zoomDoubleInState } from './zoom'
import { zoomInState, zoomOutState } from './zoom'
import { setGlobalZoomState, getGlobalZoomState } from './zoom'
import { scrollIntoView, zoomOut, zoomIn, isMobile } from './zoom'

const useZoom = ({ element }) => {
  const viewport = useRef()
  const localZoomState = useRef(zoomInitialState)
  const initialScale = 10

  useEffect(() => {
    viewport.current = {
      scale:
        visualViewport.scale < initialScale
          ? visualViewport.scale
          : initialScale,
    }

    return () => {
      if (
        getGlobalZoomState() === zoomInState &&
        localZoomState.current === zoomInState
      ) {
        setGlobalZoomState(zoomOutState)
        zoomOut({ scale: viewport.current.scale })
      }
    }
  }, [])

  useEffect(() => {
    if (element && getGlobalZoomState() === zoomOutState && isMobile()) {
      localZoomState.current = zoomInState
      setGlobalZoomState(zoomInState)
      zoomIn({ scale: viewport.current.scale })
      scrollIntoView({ element })
      return
    }

    if (
      element &&
      getGlobalZoomState() === zoomInState &&
      localZoomState.current === zoomInState
    ) {
      scrollIntoView({ element })
      return
    }

    if (element && getGlobalZoomState() === zoomInState) {
      localZoomState.current = zoomInState
      setGlobalZoomState(zoomDoubleInState)
      scrollIntoView({ element })
      return
    }

    if (
      !element &&
      getGlobalZoomState() === zoomInState &&
      localZoomState.current === zoomInState
    ) {
      localZoomState.current = zoomOutState
      setGlobalZoomState(zoomOutState)
      zoomOut({ scale: viewport.current.scale })
      return
    }

    if (
      !element &&
      getGlobalZoomState() === zoomDoubleInState &&
      localZoomState.current === zoomInState
    ) {
      localZoomState.current = zoomOutState
      setGlobalZoomState(zoomInState)
      return
    }
  }, [element])
}

export { useZoom }
export default useZoom
